export const RQ_ADD_ATTENDANCE_API = {
  url: 'api/attendance/add',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_ATTENDANCE_API = {
  url: 'api/attendance/update/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_GET_ATTENDANCE_BY_EMPLOYEE_ID_API = {
  url: 'api/attendance/lookupBy/<%= employeeId %>',
  method: 'GET',
  auth: true,
};
export const RQ_GET_ATTENDANCE_BY_EMPLOYEE_NAME_API = {
  url: 'api/attendance/lookupByName/<%= name %>',
  method: 'GET',
  auth: true,
};

export const RQ_ATTENDANCE_BY_FILTER_API = {
  url: 'api/attendance/filter',
  method: 'POST',
  auth: true,
};
export const RQ_GET_ALL_ATTENDANCE_API = {
  url: 'api/attendance/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_DELETE_ATTENDANCE_API = {
  url: 'api/attendance/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
